import React, { createContext, useContext } from "react";
import { Icon_Check } from "../Icons/icons";
import "./Steps.less";

type StepsProps = {
   children: React.ReactNode;
   current: number;
   className?: string;
   direction?: "horizontal" | "vertical";
};

type StepsContextType = {
   current: number;
};

type StepProps = {
   title: string;
   index?: number;
   description?: string;
   icon?: React.ReactNode;
};

const StepContext = createContext<StepsContextType>({ current: 0 });

const Steps = ({ children, current = 0, className = "", direction = "horizontal" }: StepsProps) => {
   const modifiedChildren = React.Children.map(children, (child, i) => {
      if (React.isValidElement<StepProps>(child)) {
         return React.cloneElement(child, {
            key: child.key,
            index: i
         });
      }
      return null;
   });
   return (
      <StepContext.Provider value={{ current }}>
         <div
            className={`${className} ${
               direction === "horizontal" ? "" : "bp2-steps--vertical"
            } bp2-steps`}
         >
            {modifiedChildren}
         </div>
      </StepContext.Provider>
   );
};

const Step = ({ title, index = 0, description, icon }: StepProps) => {
   const { current } = useContext(StepContext);
   const stepIcon = icon ? icon : index + 1;

   return (
      <div
         className={`bp2-steps-item ${current === index ? "bp2-steps-item--active" : ""} ${
            current > index ? "bp2-steps-item--finished" : ""
         }`}
      >
         <div className="bp2-steps-item__container">
            <div className="bp2-steps-item__container__icon">
               <span>
                  {current > index ? <Icon_Check fill="none" stroke="var(--first)" /> : stepIcon}
               </span>
            </div>
            <div className="bp2-steps-item__container__content">
               <div className="bp2-steps-item-tail"></div>
               <div className="bp2-steps-item__container__content__title">{title}</div>
               <div className="bp2-steps-item__container__content__description">{description}</div>
            </div>
         </div>
      </div>
   );
};

Steps.Step = Step;

export { Steps };
